import React from "react";
import classNames from "classnames/bind";
import {
    MenuIcon,
    FullVideo,
    OnStatusGreen,
} from "../../../../components/Icons/Icons";
import { SoundIcon } from "../../../../components/Icons/NotificationSetting/SoundIcon";
import { SoundIconOff } from "../../../../components/Icons/NotificationSetting/SoundIconOff";
import ListAiHeader from "./ListAiHeader";
import styles from "./StreamCam.module.css";
import { getColorForNotification } from "../../../../utils/helper";

const cx = classNames.bind(styles);

/**
 * Camera header component showing name, status, AI services, and controls
 */
const CameraHeader = ({
    item,
    screen,
    isFullScreen,
    nfc,
    isSound,
    handleToggleSound,
    handleFullScreen,
    showOptions,
    restartCamera,
}) => {
    const classNameCamerName = isFullScreen ? "font-size-name-Fs-" : "font-size-name-";
    const hasNotification = nfc.some((item1) => item1.code === item.code);
    const notificationColor = hasNotification
        ? getColorForNotification(nfc?.find((n) => n.code === item?.code)?.color)
        : null;

    return (
        <div
            className={cx("setting")}
            style={hasNotification ? { background: notificationColor } : {}}
        >
            <div className={cx("name_status")}>
                <span className={cx("On")}>
                    <OnStatusGreen />
                </span>
                <span className={cx("name", `${classNameCamerName}${screen?.total}`)}>
                    {item?.name}
                </span>
            </div>

            {/* List AI services */}
            <ListAiHeader infoAi={item} restartCamera={restartCamera} screen={screen} />

            <div className={cx("icon")} style={{ width: "100%" }}>
                {item?.list_ai_service?.length > 0 && (
                    <span onClick={() => handleToggleSound(item?.code)}>
                        {isSound ? <SoundIcon color={"#00B335"} /> : <SoundIconOff />}
                    </span>
                )}
                <span
                    className={cx("menu")}
                    onClick={(e) => handleFullScreen(item?.name, "", item.code)}
                >
                    <FullVideo />
                </span>
                <span className={cx("menu")} onClick={(e) => showOptions(item?.code)}>
                    <MenuIcon />
                </span>
            </div>
        </div>
    );
};

export default CameraHeader;

